import { render, staticRenderFns } from "./TblOrder.vue?vue&type=template&id=3ae2e070&scoped=true&"
import script from "./TblOrder.vue?vue&type=script&lang=js&"
export * from "./TblOrder.vue?vue&type=script&lang=js&"
import style0 from "./TblOrder.vue?vue&type=style&index=0&id=3ae2e070&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae2e070",
  null
  
)

export default component.exports